import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setActiveRoomColoringIdInRedux } from "../designSlice";
import {
  selectActiveRoomColoringId,
  selectRfpDefaultActiveRoomColoringId,
} from "./RFPBarSelectors";

export const useEnsureRfpDefaultActiveRoomColoringId = (): void => {
  const dispatch = useAppDispatch();
  const active = useAppSelector(selectActiveRoomColoringId);
  const defaultId = useAppSelector(selectRfpDefaultActiveRoomColoringId);

  useEffect(() => {
    if (!active && defaultId) {
      dispatch(setActiveRoomColoringIdInRedux(defaultId));
    }
  }, [active, defaultId, dispatch]);
};
